import type { ReactNode } from "react";
import React, { createContext, useContext } from "react";

import type { PageTracker } from "../integration/frontend-tracking-agent";

const defaultPageTracker: PageTracker = {
  trackGAPage: () => {},
  trackTMSPage: () => {},
};

const PageTrackerContext = createContext<PageTracker>(defaultPageTracker);

export const PageTrackerProvider = ({
  pageTracker,
  children,
}: {
  pageTracker?: PageTracker;
  children: ReactNode;
}) => (
  <PageTrackerContext.Provider value={pageTracker ?? defaultPageTracker}>
    {children}
  </PageTrackerContext.Provider>
);

export const useTrackPage = (): PageTracker => {
  return useContext(PageTrackerContext);
};
